import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenAuth } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenAuth';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenBasicInfo } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenBasicInfo';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenDetails } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenDetails';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenMedia } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenMedia';

export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreeseven = {
  /** 인증 컨텍스트 정보 */
  auth?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenAuth;
  basicInfo?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenBasicInfo;
  /** 토픽 상세 정보 */
  details?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenDetails;
  /** 미디어 정보 */
  media?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfThreesevenMedia;
};
